import news from './news'

const moduleName = 'news'
const Edit = resolve => require(['./edit'], resolve)
const routes = [
  {
    path: '/',
    redirect: '/' + moduleName
  },
  {
    path: '/' + moduleName,
    name: moduleName,
    component: news,
    meta: {
      module: moduleName
    }
  },
  {
    path: '/news/edit/:id',
    name: 'news-edit',
    component: Edit,
    props: true
  },
  {
    path: '/news/add',
    name: 'news-add',
    component: Edit,
    props: true
  }
]

export { Edit, news, routes }



// WEBPACK FOOTER //
// ./src/components/modules/news/index.js